import React from 'react';
import ShopBannerSwiper from './ShopBannerSwiper';
import '../../css/banner.css';
import '../../css/swiper.css';
import { isMobile } from 'react-device-detect';
const ShopBanner = ({ type, id }) => {
  return (
    <div className="s_banner_container">
      <div className="t_box">
        <h2>{type === 'mdpick' ? `MD'S PICK! #피규어` : '지금 뜨는 상품'}</h2>
      </div>
      <div className={isMobile ? 'm_top_visual_wp2' : 'm_top_visual_wp'}>
        <ShopBannerSwiper type={type} id={id} />
      </div>
    </div>
  );
};

export default ShopBanner;
